import { Map as IMap } from 'immutable';

export const CONSENT_STORE_NAME = 'consent';
export const ACCEPTED_CARDHOLDER_AGREEMENT = 'acceptedCardholderAgreement';


export const SET_CARDHOLDER_AGREEMENT_ACCEPTANCE = '@@storefront/SET_CARDHOLDER_AGREEMENT_ACCEPTANCE';
export const RESET_CARDHOLDER_AGREEMENT_ACCEPTANCE = '@@storefront/RESET_CARDHOLDER_AGREEMENT_ACCEPTANCE';

export const initialState = IMap({
    [ACCEPTED_CARDHOLDER_AGREEMENT]: false
});

export default function consentReducer(state = initialState, action) {
    switch (action.type) {
        case SET_CARDHOLDER_AGREEMENT_ACCEPTANCE: {
            return state.set(ACCEPTED_CARDHOLDER_AGREEMENT, action.isAccepted);
        }
        case RESET_CARDHOLDER_AGREEMENT_ACCEPTANCE: {
            return state.set(ACCEPTED_CARDHOLDER_AGREEMENT, false);
        }
        default:
            return state;
    }
}


export function setCardholderAgreementAcceptance(isAccepted) {
    return {
        type: SET_CARDHOLDER_AGREEMENT_ACCEPTANCE,
        isAccepted
    };
}

export function resetCardholderAgreementAcceptance() {
    return {
        type: RESET_CARDHOLDER_AGREEMENT_ACCEPTANCE
    };
}
